// Pages/ViewBudgetMaster.jsx
import { useEffect, useState } from "react";
import { fetchBudgetMasters } from "../Api/ViewBudgetMaster";
import { Container, Table } from "react-bootstrap";
import Dashboard from "../Components/Dashboard";
//import "../Styling/ViewBudgetMaster.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewBudgetMaster = () => {
  const [budgetMasters, setBudgetMasters] = useState([]);

  useEffect(() => {
    const loadBudgetMasters = async () => {
      try {
        const data = await fetchBudgetMasters();
        setBudgetMasters(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Budget Masters`);
      }
    };

    loadBudgetMasters();
  }, []);

  return (
    <>
      {/* <Dashboard> */}
        <div className="main-content expand">
          <Container fluid className="list-container">
            <h2 className="list-title">View Budget Masters</h2>

            {budgetMasters.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Budget ID</th>
                    <th>Budget Code</th>
                    <th>Budget Name</th>
                    <th>Company Code</th>
                    <th>Budget Status</th>
                    <th>Created At</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {budgetMasters.map((budget, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{budget.budgetID}</td>
                      <td>{budget.budgetCode}</td>
                      <td>{budget.budgetName}</td>
                      <td>{budget.companyCode}</td>
                      <td>{budget.budgetStatus}</td>
                      <td>{moment(budget.createdAt).format('L')} at {moment(budget.createdAt).format('LTS')}</td>
                      <td>{budget.createdBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No budget masters found.</p>
            )}
          </Container>
        </div>
      {/* </Dashboard> */}
    </>
  );
};

export default ViewBudgetMaster;